<template>
  <div class="home">
    <div class="banner">
      <img
        src="../../assets/home/banner-gif.gif"
        alt="banner-gif"
        class="banner-gif"
      />
      <img
        src="../../assets/home/banner-hand.png"
        alt="banner-hand"
        class="banner-hand"
      />
      <div class="banner-word">
        <p>At STARTRADER,</p>
        <p>we believe in mutual growth and success!</p>
      </div>
    </div>
    <div class="sec01">
      <p class="sec01-title">Be Our Affiliate!</p>
      <div class="sec01-cont">
        <div class="cont cont01">
          <img src="../../assets/home/sec01-01.png" alt="sec01-01" />
          <div class="sec01-word">
            <p>"CPA + Bonus"</p>
            <p>payout with no limit</p>
          </div>
        </div>
        <div class="cont cont02">
          <img src="../../assets/home/sec01-02.png" alt="sec01-02" />
          <div class="sec01-word">
            <p>Detailed Real-Time Data</p>
          </div>
        </div>
        <div class="cont cont03">
          <img src="../../assets/home/sec01-03.png" alt="sec01-03" />
          <div class="sec01-word">
            <p>Fixed Monthly</p>
            <p>Settlement Date</p>
          </div>
        </div>
      </div>
    </div>
    <div class="sec02">
      <div class="sec02-cont" ref="sec02">
        <div class="cont cont01">
          <p>Most importantly,</p>
          <p v-show="wordShow" class="scaleWord">
            Uncapped <span>Commission!</span>
          </p>
          <!-- <img
            src="../../assets/home/sec02-upper.gif"
            alt="sec02-upper"
            class="banner-gif"
          /> -->
        </div>
        <div class="cont cont02">
          <img
            src="../../assets/home/sec02-chart.gif"
            alt="sec02-chart"
            class="banner-gif"
          />
        </div>
      </div>
    </div>
    <div class="sec03">
      <div class="cont cont01">
        <img src="../../assets/home/sec03-01.png" alt="sec03-01" />
        <p>Competitve Payout Structure</p>
      </div>
      <div class="cont cont02">
        <img src="../../assets/home/sec03-02.png" alt="sec03-02" />
        <p>24/5 Multi-lingual Support</p>
      </div>
      <div class="cont cont03">
        <img src="../../assets/home/sec03-03.png" alt="sec03-03" />
        <p>Vast Marketing Tools</p>
      </div>
      <div class="cont cont04">
        <img src="../../assets/home/sec03-04.png" alt="sec03-04" />
        <p>Fast and Stable Trading Environment</p>
      </div>
      <div class="cont cont05">
        <img src="../../assets/home/sec03-05.png" alt="sec03-05" />
        <p>Real-time Dashboard</p>
      </div>
      <div class="cont cont06">
        <img src="../../assets/home/sec03-06.png" alt="sec03-06" />
        <p>Trustable International Broker</p>
      </div>
    </div>
    <div class="download">
      <p>Affiliate Agreement</p>
      <a :href="`${path}IV SVG Affiliate Agreement.pdf`" download></a>
    </div>
    <div class="footer" :style="{ padding: !isDesktop && '20px 10px 0 10px' }">
      <h3>RISK STATEMENT</h3>
      <p :style="{ 'line-height': !isDesktop && '1.4' }">
        All investments entail risks and may result in both profits and losses.
        In particular, trading leveraged derivative products such as Foreign
        Exchange (Forex) and Contracts for Difference (CFDs) carries a high
        level of risk to your capital. All these derivative products, many of
        which are leveraged, may not be appropriate for all investors. The
        effect of leverage is that both gains and losses are magnified. The
        prices of leveraged derivative products may change to your disadvantage
        very quickly, it is possible for you to lose more than your invested
        capital and you may be required to make further payments. It is
        important that you understand that with investments, your capital is at
        risk. Past performance is not a guide to future performance. It is your
        responsibility to ensure that you make an informed decision about
        whether or not to invest with us. Before deciding to invest in any
        financial product, you should carefully consider your investment
        objectives, trading knowledge and experience and affordability. You
        should seek independent professional financial advice if you do not
        understand the risks involved. You should only trade in Forex and CFDs
        if you have sufficient knowledge and experience of the risks involved in
        trading such products and if you are dealing with money that you can
        afford to lose. STARTRADER LLC assumes no liability for any loss
        sustained from trading in accordance with a recommendation. Trading via
        this website is with STARTRADER LLC.
      </p>
      <p :style="{ 'line-height': !isDesktop && '1.4' }">
        This website, including the information and materials contained in it,
        is not directed at, or intended for distribution to or use by, any
        person or entity who is a citizen or resident of or located in the
        United States or any other jurisdiction where such distribution,
        publication, availability or use would be contrary to applicable law or
        regulation.
      </p>
      <p :style="{ 'line-height': !isDesktop && '1.4' }">
        STARTRADER PRO LIMITED is authorised and regulated by the Financial
        Conduct Authority, Firm Reference Number 600837.
      </p>
      <p :style="{ 'line-height': !isDesktop && '1.4' }">
        STARTRADER LIMITED is regulated by the Seychelles Financial Services
        Authority (FSA), License No. SD049.
      </p>
      <p :style="{ 'line-height': !isDesktop && '1.4' }">
        STARTRADER LLC is a company duly incorporated in Saint Vincent & The
        Grenadines under Number 228 LLC 2019 to provide margin FX and CFDs
        trading services for global investors.
      </p>
      <div class="email">
        <p>
          <img src="./../../assets/home/email.png" alt="" />
          <a href="https://www.startrader.com" target="_blank"
            >support@startrader.com</a
          >
        </p>
      </div>
    </div>
    <!-- <a-button v-if="false" type="primary" @click="$refs.contactSalesModal.showModal()">Start Now</a-button> -->
    <!-- <ContactSalesModal ref="contactSalesModal"></ContactSalesModal> -->
  </div>
</template>

<script>
// import ContactSalesModal from '@/components/ContactSalesModal'

export default {
  name: 'Home',
  components: {},
  data() {
    return {
      // inputValue: '',
      // account: '',
      path: process.env.BASE_URL,
      wordShow: false,
    }
  },
  created() {
    console.log('2020年12月25日15:52:15')
  },
  computed: {
    isDesktop() {
      return this.$store.state.app.device === 'desktop'
    },
  },
  mounted() {
    if (
      !navigator.userAgent.match(/iPhone/i) &&
      !navigator.userAgent.match(/Android/i)
    ) {
      window.addEventListener('scroll', this.handleScroll)
      this.wordAnimate()
    } else {
      this.wordShow = true
    }
  },
  methods: {
    // 页面滑动动画
    handleScroll() {
      // 实现当滚动到指定位置，触发动画
      var a, b
      a =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop //  获取窗口滚动条高度
      b = document.documentElement.clientHeight || document.body.clientHeight // 获取浏览器可视区的高度
      var sec02 = this.$refs.sec02.offsetTop // 元素距离相对父级的高度
      if (a + b > sec02 + 200) {
        this.wordShow = true
      }
    },
    wordAnimate() {
      var sec02 = this.$refs.sec02.offsetTop
      if (document.body.clientHeight > sec02 + 200) {
        this.wordShow = true
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.home {
  font-family: 'Kanit-Medium';
  max-width: 1000px;

  p {
    margin-bottom: 0em;
    margin-block-start: 0em;
    margin-block-end: 0em;
  }

  /* banner */
  .banner {
    background-color: #f9f9f9;
    position: relative;
    height: 450px;
    font-size: 0;

    .banner-gif {
      position: absolute;
      width: 328px;
      top: 50px;
      left: 30px;
    }

    .banner-hand {
      position: absolute;
      width: 519px;
      top: 0;
      right: 0;
    }

    .banner-word {
      position: absolute;
      text-align: start;
      top: 264px;
      left: 426px;

      p {
        font-size: 26px;
        line-height: 34px;
        color: #4c5085;
        letter-spacing: 0.6px;
      }
    }
  }

  /* sec01 */
  .sec01 {
    width: 100%;
    height: 270px;
    background: url('../../assets/home/sec01-bg.jpg') no-repeat;
    background-size: 100% 100%;
    padding-top: 64px;
    line-height: 24px;

    .sec01-title {
      font-size: 30px;
      color: #4c5085;
    }
    .sec01-cont {
      display: flex;
      justify-content: space-around;
      padding: 0 60px;
      margin-top: 54px;

      .cont {
        width: 30%;
        text-align: center;
        font-size: 0;

        img {
          margin-bottom: 18px;
        }

        p {
          font-size: 16px;
          font-family: 'Kanit-Light';
          color: #4c5085;
          line-height: 15px;
        }
      }

      .cont01 img {
        width: 78px;
      }

      .cont02 {
        p {
          margin-top: 4px;
        }

        img {
          width: 82px;
        }
      }

      .cont03 img {
        width: 84px;
      }

      .cont03 .sec01-word {
        margin-left: 16px;
      }
    }
  }

  /* sec02 */
  .sec02 {
    width: 100%;
    background: #ffffff;
    padding-bottom: 20px;

    .sec02-cont {
      display: flex;

      .cont01 {
        width: 68%;
        padding-top: 116px;

        p:nth-child(1) {
          font-size: 26px;
          line-height: 26px;
          color: #4c5085;
          margin-bottom: 20px;
        }

        p:nth-child(2) {
          font-size: 42px;
          color: #12226e;
          margin-bottom: 20px;
          font-weight: 700;
          letter-spacing: 0.6px;

          span {
            color: #6f9bcc;
          }
        }
        .scaleWord {
          -webkit-animation: scaleWord 0.8s linear;
          -moz-animation: scaleWord 0.8s linear;
          -o-animation: scaleWord 0.8s linear;
          animation: scaleWord 0.8s linear;
        }

        @mixin keyframes($animationName) {
          @-webkit-keyframes #{$animationName} {
            @content;
          }
          @-moz-keyframes #{$animationName} {
            @content;
          }
          @keyframes #{$animationName} {
            @content;
          }
          @-o-keyframes #{$animationName} {
            @content;
          }
        }
        @include keyframes(scaleWord) {
          0% {
            transform: scale(1);
            opacity: 0.7;
          }
          55% {
            transform: scale(1.1);
            opacity: 0.9;
          }
          100% {
            transform: scale(1.2);
            opacity: 1;
          }
        }
      }

      .cont02 {
        margin-top: 50px;
        img {
          width: 220px;
        }
      }
    }
  }

  /* sec03 */
  .sec03 {
    width: 100%;
    background: #f9f9f9;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    padding: 60px 80px 30px 80px;

    .cont {
      width: 28%;
      padding-bottom: 50px;

      p {
        font-size: 14px;
        line-height: 16px;
        font-family: 'Kanit-Light';
        color: #4c5085;
        margin-top: 28px;
      }

      img {
        width: 100px;
      }
    }
  }

  /* download */
  .download {
    width: 100%;
    height: 351px;
    background: url('../../assets/home/download-bg.jpg') no-repeat;
    background-size: 100% 100%;
    padding-top: 100px;

    p {
      font-size: 30px;
      line-height: 30px;
      color: #4c5085;
      margin-bottom: 44px;
    }

    a {
      display: inline-block;
      width: 63px;
      height: 63px;
      background: url('../../assets/home/download.png') no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
    }
  }

  /* footer */
  .footer {
    width: 100%;
    background: #eee;
    padding: 50px 0 30px 0;

    h3 {
      font-size: 16px;
      line-height: 1.5;
      color: #4c5085;
      text-align: left;
    }
    p {
      font-size: 12px;
      margin-bottom: 20px;
      color: #4c5085;
      text-align: justify;
    }
    .email {
      display: inline-block;
    }
    .email img {
      vertical-align: middle;
      padding-right: 3px;
      width: 24px;
    }
    a {
      text-decoration: none;
      background-color: transparent;
      outline: none;
      cursor: pointer;
      color: #4c5085;
      font-size: 16px;
    }
  }

  @media screen and (max-width: 750px) {
    .banner {
      width: 100%;
      height: 210px;
      .banner-gif {
        position: absolute;
        width: 145px;
        top: 32px;
        left: 20px;
      }
      .banner-hand {
        position: absolute;
        width: 208px;
        top: 0;
        right: 0;
      }
      .banner-word {
        position: absolute;
        text-align: start;
        top: 110px;
        left: 184px;

        p {
          font-size: 16px;
          line-height: 20px;
          color: #4c5085;
          letter-spacing: 0px;
        }
      }
    }
    /* sec01 */
    .sec01 {
      width: 100%;
      height: 203px;
      background: url('../../assets/home/sec01-bg.jpg') no-repeat;
      background-size: 100% 100%;
      padding-top: 30px;
      line-height: 14px;

      .sec01-title {
        font-size: 24px;
        color: #4c5085;
      }
      .sec01-cont {
        display: flex;
        justify-content: space-around;
        padding: 0 20px;
        margin-top: 35px;

        .cont {
          width: 32%;
          text-align: center;
          font-size: 0;

          img {
            margin-bottom: 18px;
          }

          p {
            font-size: 14px;
            font-family: 'Kanit-Light';
            color: #4c5085;
            line-height: 15px;
          }
        }

        .cont01 img {
          width: 60px;
        }

        .cont02 {
          p {
            margin-top: 4px;
          }

          img {
            width: 63px;
          }
        }

        .cont03 img {
          width: 65px;
        }

        .cont03 .sec01-word {
          margin-left: 16px;
        }
      }
    }
    /* sec02 */
    .sec02 {
      width: 100%;
      background: #ffffff;
      padding-bottom: 20px;

      .sec02-cont {
        display: flex;

        .cont01 {
          width: 68%;
          padding-top: 50px;

          p:nth-child(1) {
            font-size: 18px;
            line-height: 26px;
            color: #4c5085;
            margin-bottom: 18px;
          }

          p:nth-child(2) {
            font-size: 30px;
            line-height: 32px;
            color: #12226e;
            margin-bottom: 20px;
            font-weight: 700;
            letter-spacing: 0.6px;

            span {
              color: #6f9bcc;
            }
          }
          .scaleWord {
            -webkit-animation: scaleWord 0.8s linear;
            -moz-animation: scaleWord 0.8s linear;
            -o-animation: scaleWord 0.8s linear;
            animation: scaleWord 0.8s linear;
          }

          @mixin keyframes($animationName) {
            @-webkit-keyframes #{$animationName} {
              @content;
            }
            @-moz-keyframes #{$animationName} {
              @content;
            }
            @keyframes #{$animationName} {
              @content;
            }
            @-o-keyframes #{$animationName} {
              @content;
            }
          }
          @include keyframes(scaleWord) {
            0% {
              transform: scale(1);
              opacity: 0.7;
            }
            55% {
              transform: scale(1.1);
              opacity: 0.9;
            }
            100% {
              transform: scale(1.2);
              opacity: 1;
            }
          }
        }

        .cont02 {
          margin-top: 30px;
          img {
            width: 150px;
          }
        }
      }
    }
    /* sec03 */
    .sec03 {
      width: 100%;
      background: #f9f9f9;
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
      padding: 30px 20px 10px 20px;

      .cont {
        width: 30%;
        padding-bottom: 20px;

        p {
          font-size: 14px;
          line-height: 16px;
          font-family: 'Kanit-Light';
          color: #4c5085;
          margin-top: 16px;
        }

        img {
          width: 60px;
        }
      }
    }
    /* download */
    .download {
      width: 100%;
      height: 214px;
      background: url('../../assets/home/download-bg.jpg') no-repeat;
      background-size: 100% 100%;
      padding-top: 40px;

      p {
        font-size: 28px;
        line-height: 30px;
        color: #4c5085;
        margin-bottom: 20px;
      }

      a {
        display: inline-block;
        width: 50px;
        height: 50px;
        background: url('../../assets/home/download.png') no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
      }
    }
  }
  @media screen and (min-width: 540px) and (max-width: 660px) {
    .banner {
      width: 100%;
      height: 300px;
      .banner-gif {
        position: absolute;
        width: 210px;
        top: 30px;
        left: 30px;
      }

      .banner-hand {
        position: absolute;
        width: 260px;
        top: 0;
        right: 0;
      }

      .banner-word {
        position: absolute;
        text-align: start;
        top: 160px;
        left: 280px;

        p {
          font-size: 18px;
          line-height: 20px;
          color: #4c5085;
          letter-spacing: 0.6px;
        }
      }
    }
  }
  @media screen and (min-width: 661px) and (max-width: 750px) {
    .banner {
      width: 100%;
      height: 300px;
      .banner-gif {
        position: absolute;
        width: 230px;
        top: 30px;
        left: 30px;
      }

      .banner-hand {
        position: absolute;
        width: 290px;
        top: 0;
        right: 0;
      }

      .banner-word {
        position: absolute;
        text-align: start;
        top: 160px;
        left: 290px;

        p {
          font-size: 20px;
          line-height: 20px;
          color: #4c5085;
          letter-spacing: 0.6px;
        }
      }
    }
  }
  @media screen and (min-width: 751px) and (max-width: 940px) {
    .banner {
      width: 100%;
      height: 380px;
      .banner-gif {
        position: absolute;
        width: 280px;
        top: 50px;
        left: 30px;
      }

      .banner-hand {
        position: absolute;
        width: 360px;
        top: 0;
        right: 0;
      }

      .banner-word {
        position: absolute;
        text-align: start;
        top: 200px;
        left: 340px;

        p {
          font-size: 24px;
          line-height: 30px;
          color: #4c5085;
          letter-spacing: 0.6px;
        }
      }
    }
  }
  @media screen and (min-width: 751px) and (max-width: 1020px) {
    .footer {
      width: 100%;
      background: #eee;
      padding: 50px 10px 30px 10px;
    }
  }
}
</style>
